import PropTypes from "prop-types";
import LineChart from "./LineChart";

function EvolucionSatisfaccionChart({ data, period, customDates }) {
  return (
    <LineChart
      data={data}
      period={period}
      customDates={customDates}
      title="Evolución de Satisfacción por Nota"
      height={400}
      legendPosition="right"
      showFilter={true}
      filterLabel="Notas"
      defaultSelectedCount={7}
      noDataMessage="No hay datos de evolución para el período seleccionado"
      noSelectionMessage="Selecciona al menos una nota para visualizar el gráfico"
      stepSize={10}
      tension={0.4}
      useConsistentColors={true}
    />
  );
}

EvolucionSatisfaccionChart.propTypes = {
  data: PropTypes.shape({
    labels: PropTypes.arrayOf(PropTypes.string),
    datasets: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      data: PropTypes.arrayOf(PropTypes.number)
    }))
  }),
  period: PropTypes.string.isRequired,
  customDates: PropTypes.shape({
    startDate: PropTypes.string,
    endDate: PropTypes.string,
  }),
};

export default EvolucionSatisfaccionChart;